export default [
    {
        name: "email",
        label: "Email",
        type: "string",
    },
    {
        name: "roleIds",
        label: "Roles",
        type: "list",
        helpText: "Roles",
        url: "/roles",
        filterValue: "name",
        entityName: "roles",
        formatLabels: true,
        include: true,
    },
    {
        name: "createdAt",
        label: "Joined At",
        type: "date",
    },
    {
        name: "updatedAt",
        label: "Updated At",
        type: "date",
    },
    {
        name: "signInCount",
        label: "Sign In Count",
        type: "string",
    },
    {
        name: "currentSignInAt",
        label: "Current Sign In At",
        type: "date",
    },
    {
        name: "currentSignInIp",
        label: "Current Sign In IP Address",
        type: "string",
    },
    {
        name: "lastSignInAt",
        label: "Last Sign In At",
        type: "date",
    },
    {
        name: "lastSignInIp",
        label: "Last Sign In IP Address",
        type: "string",
    },
];
